import {observer} from 'mobx-react';
import {
  Input, FormLayout, DatePicker, TimeInput, CheckboxWithLabel, TextArea
} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';

const StartDate = observer(({uiState, label, errorMessage}) => {
  const {editingCustomEvent} = uiState;

  return (
    <DatePicker
      label={label}
      value={editingCustomEvent.startDate}
      errorMessage={errorMessage}
      onChange={date => editingCustomEvent.setStartDate(date)}
    />
  );
});

const AllDayDates = observer(({uiState}) => {
  const {errors, editingCustomEvent} = uiState;

  return (
    <FormLayout.Group>
      <StartDate
        uiState={uiState}
        label='calendar.custom_events.Start Date'
        errorMessage={errors.startsAt}
      />
      <DatePicker
        label='calendar.custom_events.End Date'
        value={editingCustomEvent.endsAt}
        errorMessage={errors.endsAt}
        options={{startDate: editingCustomEvent.startsAt}}
        onChange={date => editingCustomEvent.setEndDate(date)}
      />
    </FormLayout.Group>
  );
});

const EventTimes = observer(({uiState}) => {
  const {errors, editingCustomEvent} = uiState;

  return (
    <FormLayout.Group>
      <TimeInput
        label='calendar.custom_events.Start Time'
        initialValue={editingCustomEvent.startTime}
        errorMessage={errors.startsAt}
        onFormat={({value, error}) => !error && editingCustomEvent.setStartTime(value)}
      />
      <TimeInput
        label='calendar.custom_events.End Time'
        initialValue={editingCustomEvent.endTime}
        lowerBound={editingCustomEvent.startTime}
        errorMessage={errors.endsAt}
        onFormat={({value, error}) => !error && editingCustomEvent.setEndTime(value)}
      />
    </FormLayout.Group>
  );
});

const EditCustomEventModal = observer(({uiState, modalOpen}) => {
  const {errors, editingCustomEvent} = uiState;

  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeEditCustomEventModal()}
      size='md'
      title={editingCustomEvent.isNew ?
        'calendar.custom_events.Create Event' :
        'calendar.custom_events.Edit Event'}
    >
      <FormLayout>
        <Input
          label='calendar.custom_events.Title'
          value={editingCustomEvent.title}
          errorMessage={errors.title}
          onChange={e => editingCustomEvent.merge({title: e.target.value})}
        />
        <CheckboxWithLabel
          translatable
          label='calendar.custom_events.All day'
          checked={editingCustomEvent.allDay}
          onChange={({checked}) => editingCustomEvent.setAllDay(checked)}
        />
        {editingCustomEvent.allDay && <AllDayDates uiState={uiState}/>}
        {!editingCustomEvent.allDay &&
          <StartDate uiState={uiState} label='calendar.custom_events.Date'/>}
        {!editingCustomEvent.allDay && <EventTimes uiState={uiState}/>}
        <TextArea
          label='calendar.custom_events.Description'
          value={editingCustomEvent.description}
          errorMessage={errors.description}
          onChange={e => editingCustomEvent.merge({description: e.target.value})}
        />
      </FormLayout>
      <ModalButtons
        onSave={() => uiState.saveCustomEvent()}
        onCancel={() => uiState.closeEditCustomEventModal()}
      />
    </Modal>
  );
});

export default EditCustomEventModal;
